import { StatusBadge } from '@/components/medplum-react/StatusBadge/StatusBadge';
import { formatDateTime } from '@medplum/core';
import { Encounter } from '@medplum/fhirtypes';
import React from 'react';
import { TFunction } from 'i18next';

export const renderEncounterCell = (
  resource: Encounter,
  field: { name: string },
  t?: TFunction<'encounters'>
): React.ReactNode => {
  if (field.name === 'status') {
    const code = resource.status ?? 'unknown';

    const label = t
      ? t(`statusOptions.${code}`, {
          ns: 'encounters',
          defaultValue: code.replace(/-/g, ' '),
        })
      : code.replace(/-/g, ' ');

    return <StatusBadge status={code} label={label} />;
  }

  if (field.name === 'participant') {
    const participants = resource.participant ?? [];
    return (
      <>
        {participants
          .map(
            (p) => p.individual?.display || p.individual?.reference || 'Unknown'
          )
          .join(', ')}
      </>
    );
  }

  if (field.name === 'period') {
    return resource.period?.start ? formatDateTime(resource.period.start) : '';
  }

  if (field.name === 'type') {
    const code =
      resource.type?.[0]?.coding?.[0]?.code ??
      resource.type?.[0]?.text?.toLowerCase().replace(/\s+/g, '-');
    const textFromCoding =
      (t &&
        code &&
        t(`types.${code}`, { ns: 'encounters', defaultValue: '' })) ||
      '';
    const fallbackText = resource.type?.[0]?.text ?? '';
    const value = textFromCoding || fallbackText || code || '';
    return value || '';
  }

  return undefined;
};
